import { Api } from "../../Services/Api";
import { Dispatch } from "../Dispatch";
import { SdkLoadingState } from "../PayPal/PayPalState";

export async function LoadCabchargeDigitalProductIFrame() {

    Dispatch.Payment.IFrameLoadingState(SdkLoadingState.InProgress);

    const iFrameResult = await Api.PaymentV2.GetCabchargeDigitalProductActivationUrl();

    if (!iFrameResult.isSuccess) {
        Dispatch.Payment.IFrameLoadingState(SdkLoadingState.FinishedError);
        return;
    }

    Dispatch.Payment.RefreshIFrameUrl(iFrameResult.value.IFrameUrl);
    Dispatch.Payment.IFrameLoadingState(SdkLoadingState.FinishedSuccess);
}